"use strict";

exports.__esModule = true;
exports.msg = exports.setIntl = exports.intl = exports.injectIntl = void 0;

var _reactIntl = require("react-intl");

exports.injectIntl = _reactIntl.injectIntl;
var intl = null;
exports.intl = intl;

var setIntl = function setIntl(i) {
  exports.intl = intl = i;
};

exports.setIntl = setIntl;

var msg = function msg(key, values) {
  var descriptor = key;

  if (typeof key === 'string') {
    descriptor = {
      id: key,
      defaultMessage: key,
      description: key
    };
  }

  return intl && intl.formatMessage(descriptor, values);
};

exports.msg = msg;